import LoadingLogo from '@components/Loading/LoadingLogo';
import useTranslation from '@components/Translation/useTranslation';
import { Modal, ModalID } from '@repo/ui/src/modules/UI';

const CheckoutLoader = () => {
  const { t } = useTranslation();
  return (
    <Modal
      id={ModalID.checkoutLoader}
      aria-label="loading screen"
      fullScreen
      noButcherPaper
      disableClose
      className="tw-bg-white"
    >
      <div className="tw-flex tw-flex-col tw-justify-center tw-align-center tw-h-full tw-w-full">
        <div className="tw-max-h-40">
          <LoadingLogo />
        </div>
        <h5 className="tra-text-web-heading-6 tw-text-center tw-pt-5 tw-text-text-300">
          {t('cart.continueToCheckout', undefined, { default: 'Taking you to Checkout' })}
        </h5>
        <button
          className="tra-text-web-body-s tw-max-w-xs tw-text-center tw-mx-auto tw-py-5"
          onClick={() => window.location.reload()}
        >
          {t('cart.loadingButtonText', undefined, {
            default: 'If you are not redirected please click here',
          })}
        </button>
      </div>
    </Modal>
  );
};

export default CheckoutLoader;
